import { render, staticRenderFns } from "./pos-change-badge-product-modal.vue?vue&type=template&id=e0b7d374&scoped=true&"
import script from "./pos-change-badge-product-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-change-badge-product-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b7d374",
  null
  
)

export default component.exports